export default function assert(condition) {
  if (!condition) {
    throw new Error('viewport-mercator-project: assertion failed.');
  }
}
//# sourceMappingURL=assert.js.map


//////////////////
// WEBPACK FOOTER
// ./~/viewport-mercator-project/dist/esm/assert.js
// module id = 872
// module chunks = 0